// extracted by mini-css-extract-plugin
export default {"staff":"staff_staff__EAmgG","staff__list":"staff_staff__list__iGA5O"};